import { useMemo } from "react";
import { useOwnHomeRateBand } from "web_myplann/Inspiration/OwnHome/Hooks/useOwnHomeRateBand";
import type {
	OwnHomeContext,
	OwnHomeInputs,
} from "web_myplann/Inspiration/OwnHome/Types/OwnHomeTypes";
import { computeOwnHomeContext } from "web_myplann/Inspiration/OwnHome/Utils/ownHomeMath";

type Result = {
	context: OwnHomeContext | null;
	isLoading: boolean;
};

export const useOwnHomeContext = (inputs: OwnHomeInputs): Result => {
	const { rates, isLoading } = useOwnHomeRateBand({ rent: inputs.rent });

	const context = useMemo(
		() => (rates ? computeOwnHomeContext(inputs, rates) : null),
		[inputs, rates],
	);

	return { context, isLoading };
};
